export default "__VITE_ASSET__QohDfykh__"